import { Link, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import T from '@wojtekmaj/react-t';

import { FormWrapper, HeaderAndFormWrapper, Main, PageWrapper } from '../login/index.styles';

import Footer from '../../footer';
import Header from '../../header';
import Heading from '../../heading';
import RegisterWithDetailsStepDetails from './details';
import RegisterWithDetailsStepRegister from './register';

export default function RegisterWithDetailsPage() {
  const location = useLocation();

  return (
    <PageWrapper>
      <HeaderAndFormWrapper>
        <Header />
        <FormWrapper>
          <Main>
            <Heading align="center">Register</Heading>
            <Routes>
              <Route element={<RegisterWithDetailsStepRegister />} path="register" />
              <Route element={<RegisterWithDetailsStepDetails />} path="details" />
              <Route
                element={
                  <Navigate
                    state={location.state}
                    to={{
                      pathname: 'register',
                      search: location.search,
                    }}
                  />
                }
                path="*"
              />
            </Routes>
            <p>
              <T>Already have an account?</T>{' '}
              <Link state={location.state} to="/login">
                <T>Login</T>
              </Link>
              .
            </p>
          </Main>
        </FormWrapper>
      </HeaderAndFormWrapper>
      <Footer />
    </PageWrapper>
  );
}
